import { moduleIdProp } from 'root/src/client/logic/route/lenses'
import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewSubmitsFullWidth } = formModuleLenses

export default (state, props) => viewSubmitsFullWidth(
	moduleIdProp(props), moduleDescriptions,
)
